
import { IBlogsModel } from 'models/IBlogs.Model';
import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardFooter, Col, Container, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import CommonService from 'services/CommonService';
import { useNavigate } from 'react-router-dom';
import StatusStatsFilters from 'components/filter/StatusStatsFilters';
import CustomDataTable from 'components/shared/CustomDataTable';
import { IColumnModel } from 'models/IColumnModel';
import BrandMasterServices from "../../../services/Master.Service"
import { HelperConstant } from "../../../helpers/HelperConstant";
import { CustomToaster } from 'components/shared/CustomToaster';
import CustomLoader from 'components/Common/CustomLoader';

interface Blog {
    StatusName?: string;
    Name: string;
    TitleOfThePage: string;
    EditionDate: string;
    ImagePath: string;
    ImageAltName: string;
    ImageTitleName: string;
    ShortDescription: string;
    ContentDetails: string;
    LinkedInPath?: string;
    XPath?: string;
    TotalRowsCount:any;
    FacebookPath?: string;
    DisplayInList: boolean;
    BlogFAQ?: IBlogFAQModel[];
    UploadFiles: string;
    BlogId: number;
    Created: string;
    CreatedBy: number;
    Active: boolean;
    Modified: string;
    ModifiedBy: number;
    RowOrder: number;
    SchemaContent?: string
    Id: number;
    IsValid: boolean;
    ValidationErrors: {
        Items: any[];
    };
}
interface IBlogFAQModel {
    Id: Number,
    Question: string,
    Answer: string,
    DisplayInList: boolean,
    Active: boolean,
    RowOrder: Number,
    Created: any,
    CreatedBy: number,
    Modified: any,
    ModifiedBy: number,
}

type TransformedItem = {
    Id: number;
    Name: string;
    EnumName?: string;
    StatsCount: number;
};


function BlogDashboard() {
    const [load, setLoad] = useState<boolean>(false);
    const [dltModal, setDltModal] = useState(0);
    const [deleteBlogId, setDeleteBLogId] = useState()
    const [createModal, setCreate] = useState(0);
    const [statusList, setStatusList] = useState<TransformedItem[]>([]);
    const [apiResMsg, setapiRes] = useState<string>("");
    const [toast, setToast] = useState(false);
    const [recordsCount, setRecordsCount] = useState<number>(0);
    const [blogs, setBlogs] = useState<Blog[]>([]);
    const [searchText, setSearchText] = useState<any>();
    const [fromDate, setFromDate] = useState<string | null>(null);
    const [toDate, setToDate] = useState<string | null>(null);
    const [isStatusId, setIsStatusId] = useState(0);
    const navigate = useNavigate();
    const [rowsPerPage] = useState<number>(50);
    const [currentPage, setCurrentPage] = useState<any>(1);
    const [offsetStart, setOffsetStart] = useState<number>(0);
    const statusName = isStatusId ? statusList.filter(x => x.Id == isStatusId)[0]?.Name : HelperConstant.Request_For_Blog_StatusEnums.All;
    const searchByText = (searchText?: any, statusid?: any, isPublished?: boolean, isDisplayInListed?: boolean) => {
        setLoad(true)
        let searchModel: IBlogsModel = {
            offsetStart: offsetStart,
            rowsPerPage: rowsPerPage,
            sortOrder: "desc",
            sortOrderColumn: "modified",
            searchText: searchText,
            createdStartDate: fromDate,
            createdEndDate: toDate,
            isPublish: isPublished,
            displayInList: isDisplayInListed,
            StatusId: statusid,
        }
        CommonService.post("Blog", 'GetAllBlogs', searchModel).then(res => {
            if (res.status === 200) {
                setBlogs(res.data.Items);
                setRecordsCount(res.data.RecordsCount)
                setLoad(false)
            }
        }).catch(e => console.log(e));
        BrandMasterServices.getBlogCount()
            .then(res => {
                if (res.status === 200) {
                    setStatusList(res.data);
                }
            })
            .catch((e: string) => {
                console.error("Error fetching blog count:", e);
            });

    }

    const routeHandler = (value: any) => {
        const routeId = value.Id
        setLoad(true)
        navigate(`/blogcreateedit/${routeId}`)
    }
    const dltBlog = (val) => {
        setDeleteBLogId(val.Id)
        setDltModal(1)
    }
    const deleteBlog = (val: any) => {
        setLoad(true)
        const updateData = blogs.map((blog) => {
            if (blog.Id === val) {
                CommonService.postWithSingleParam("Blog", "Remove", blog.Id).then(res => {
                    if (res.status === 200) {
                        setLoad(false)
                        setToast(true)
                        setapiRes("Update successfully")
                        window.location.reload();
                    }
                }).catch(e => {
                    setToast(true)
                    setapiRes(e)
                    console.error('Error:', e);
                });
                return { ...blog, Active: false };
            }
            return blog;
        })
        setBlogs(updateData);
    }
    const searchHandler = (searchKeyword: any) => {
        setSearchText(searchKeyword);
        searchByText(searchKeyword, isStatusId);
    }
    useEffect(() => {
        searchByText(searchText, isStatusId);
    }, [offsetStart, rowsPerPage, isStatusId, fromDate, toDate, statusName]);
    useEffect(() => {
        if (createModal > 0) {
            setLoad(true)
            window.location.href = "/blogcreateedit";
        }
    }, [createModal])

    const IndiaColumns: IColumnModel[] = useMemo(() => [

        {
            Header: 'Edition Date',
            accessor: 'EditionDate',
            width: "5%",
            displayInList: true,
            Filter: true,
            datatype: "date"
        },
        {
            Header: 'Title Of The Page',
            accessor: (row: any) =>
                row.Name?.length > 60
                    ? row.Name.substring(0, 60) + "..."
                    : row.Name,
            Filter: true,
            displayInList: true,
            width: "40%",
            isSortable: true,
        },
        {
            Header: 'Created By',
            accessor: 'CreatedPerson',
            Filter: true,
            displayInList: true,
            width: "5%",
        },
        {
            Header: 'Modified By',
            accessor: 'ModifiedPerson',
            width: "5%",
            displayInList: true,
            Filter: true,
        },
        {
            Header: 'Status',
            accessor: 'StatusName',
            Filter: true,
            displayInList: true,
            width: "5%"
        },

    ], []);
    const onColumnSortChange = (columnName, sortValue) => {
        // setSelectedColumn(columnName);
        // setSortOrder(sortValue);
        // locationRequestData(0, debouncedSearch, isStatusId, columnName, sortValue)
    };
    const pagination = (pageNumber: any) => {
        searchByText(searchText, isStatusId)
    }

    return (
        <div className='page-content'>

            <Container fluid className="p-0">
                <div className="d-flex justify-content-between">
                    <h5 className="fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>BLOGS</h5>
                </div>
                <div className=' mb-3 border-bottom border-4'>
                    <StatusStatsFilters statusList={statusList.sort((a, b) => a.Name?.toLowerCase()?.localeCompare(b.Name?.toLowerCase()))} splitCol={3} isWantExport={false} onClick={(id: any) => { setIsStatusId(id) }} statusName={statusName} onExport={undefined} onFromDateChange={(value: any) => setFromDate(value)} onToDateChange={(value: any) => setToDate(value)} CreatedFromDateLabel="FromDate" CreatedToDateLabel="ToDate" />
                </div>
                <Row >

                    <Col xl={12}>
                        {recordsCount > 0 ?
                            <CustomDataTable
                                data={blogs} columns={IndiaColumns}
                                isPagination={blogs[0]?.TotalRowsCount > 50 ? true : true}
                                customPageSize={50}
                                isActionEdit={false}
                                isActionDelete={false}
                                editHandler={routeHandler}
                                isGlobalFilter={true}
                                searchHandler={searchHandler}
                                shareHandler={true}
                                onColumnSortChange={onColumnSortChange}
                                canShowButton1={true}
                                selectedPage={pagination}
                                canShowButton2={false}
                                deleteHandler={dltBlog}
                                createHandler={undefined}
                                path={''}
                                firstBtnName={'Create'}
                                specialGrid={false}
                                recordsCount={blogs[0]?.TotalRowsCount}
                                pageSize={recordsCount}
                                linkBtnhandler={routeHandler}
                                routeHandler={() => setCreate(1)} rowsPerPage={rowsPerPage} currentPage={currentPage} setCurrentPage={setCurrentPage} offsetStart={offsetStart} setOffsetStart={setOffsetStart} /> :
                            <CustomDataTable

                                data={[]} columns={IndiaColumns}
                                isPagination={false}
                                customPageSize={50}
                                isActionEdit={true}
                                isActionDelete={false}
                                isGlobalFilter={true}
                                editHandler={routeHandler}
                                searchHandler={searchHandler}
                                linkBtnhandler={routeHandler}
                                canShowButton1={true}
                                canShowButton2={false}
                                deleteHandler={undefined}
                                createHandler={undefined}
                                path={''}
                                firstBtnName={"Create"}
                                pageSize={50}
                                routeHandler={() => setCreate(1)}
                                rowsPerPage={rowsPerPage} currentPage={currentPage} setCurrentPage={setCurrentPage} offsetStart={offsetStart} setOffsetStart={setOffsetStart}
                            />}

                    </Col>
                </Row>
                <Modal isOpen={dltModal > 0} toggle={() => setDltModal(0)} centered={true} backdrop size={"sm"}>
                    <div className="modal-content p-0">
                        <ModalBody className="px-2 py-5 text-center">
                            <div className="avatar-sm mb-4 mx-auto">
                                <div className={" bg-danger avatar-title text-primary bg-opacity-10 fs-1 rounded-3"}>
                                    <i className={`bx bx-error text-danger`}></i>
                                </div>
                            </div>
                            <p className="text-muted font-size-14 mb-4">Are you sure, you want to permanently delete this blog admin and public sides?</p>

                            <div className="hstack gap-2 justify-content-center mb-0">
                                <button type="button" className="btn btn-soft-secondary" onClick={() => setDltModal(0)}>Close</button>
                                <button type="button" className={`btn btn-danger`} onClick={() => deleteBlog(deleteBlogId)}>Delete</button>

                            </div>
                        </ModalBody>
                    </div>
                </Modal>
                <CustomLoader isOpen={load} />
                <CustomToaster message={apiResMsg} color={'text-success'} toast={toast} setToast={setToast} customTime={1000} />
            </Container>

        </div >
    )
}

export default BlogDashboard